var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconShareLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  rx: 16,
  fill: "black",
  fillOpacity: 0.7
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_19785_136107)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.6668 16.6665C14.9531 17.0492 15.3184 17.3659 15.7379 17.5951C16.1573 17.8243 16.6212 17.9606 17.0979 17.9947C17.5747 18.0288 18.0532 17.9601 18.5011 17.793C18.9489 17.6259 19.3556 17.3645 19.6935 17.0265L21.6935 15.0265C22.3007 14.3978 22.6367 13.5558 22.6291 12.6818C22.6215 11.8078 22.2709 10.9718 21.6529 10.3538C21.0349 9.73573 20.1988 9.38516 19.3248 9.37757C18.4508 9.36997 17.6088 9.70595 16.9802 10.3131L15.8335 11.4531M17.3335 15.3332C17.0472 14.9504 16.6819 14.6337 16.2624 14.4045C15.843 14.1754 15.3791 14.0391 14.9024 14.0049C14.4256 13.9708 13.9471 14.0396 13.4992 14.2066C13.0514 14.3737 12.6447 14.6351 12.3068 14.9732L10.3068 16.9732C9.69961 17.6018 9.36363 18.4438 9.37122 19.3178C9.37881 20.1918 9.72938 21.0279 10.3474 21.6459C10.9654 22.2639 11.8015 22.6145 12.6755 22.6221C13.5495 22.6297 14.3915 22.2937 15.0201 21.6865L16.1601 20.5465",
  stroke: "white",
  strokeWidth: 1.0875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_19785_136107"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(8 8)"
})))));
export default SvgIconShareLink;